import { GenericBackgroundImage } from 'takeovers/utils/components/GenericBackgroundImage'
import { rem } from 'polished'
import useResponsiveSelector from 'hooks/useResponsiveSelector'
import LuxPlusExperienceDiscountTakeoverBackground from 'takeovers/luxplusExperienceDiscountTakeover/components/LuxPlusExperienceDiscountTakeoverBackground'
import { useShowExperienceDiscountBanner } from 'takeovers/luxplusExperienceDiscountTakeover/hooks/useShowExperienceDiscountBanner'

interface Props {
  className?: string
  background?: App.SiteTakeoverBackground
  imageId?: string
  placement?: App.SiteTakeoverPlacement
}

function MaldivesCharterTakeoverBackground(props: Props) {
  const { className, imageId, placement } = props
  const shouldShowExperienceDiscountBanner = useShowExperienceDiscountBanner()
  const backgroundStyle = useResponsiveSelector({
    mobile: '#1776EB',
    tablet: '#1776EB',
  }) ?? 'linear-gradient(90deg, #1776EB 0%, #52DBE8 99.04%)'

  // Use LuxPlus background for site-wide banner in experience-enabled regions until Jan 5, 2026
  if (placement === 'siteWideBanner' && shouldShowExperienceDiscountBanner) {
    return <LuxPlusExperienceDiscountTakeoverBackground className={className} />
  }

  return (
    <GenericBackgroundImage
      className={className}
      imageId={imageId || 'maldives-gradient-bg'}
      backgroundStyle={backgroundStyle}
      attachments={[
        {
          imageId: 'maldives-big-left-palm-tree',
          left: rem(24),
          bottom: rem(-224),
          min: 'desktop',
        },
        {
          imageId: 'maldives-right-palm-tree',
          right: rem(160),
          bottom: rem(-168),
          min: 'desktop',
        },
      ]}
    />
  )
}

export default MaldivesCharterTakeoverBackground
